<template>
  <main class="mobile-page app-screen">
    <div class="mobile-screen">
      <header class="mobile-topnav transparent">
        <RouterLink class="mobile-icon-btn solid" to="/mobile" aria-label="返回首页">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M14.5 5.5 8 12l6.5 6.5" /></svg>
        </RouterLink>
        <span class="mobile-topnav-title compact">点指之间 APP</span>
        <RouterLink class="mobile-icon-btn solid" :to="registerTo" aria-label="受邀注册">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18.5 8v6M15.5 11h6" /><circle cx="9" cy="8.5" r="3.2" /><path d="M3.5 19.5c1-3.3 3-4.8 5.5-4.8s4.5 1.5 5.5 4.8" /></svg>
        </RouterLink>
      </header>

      <section class="app-hero">
        <img class="hero-image" src="/images/pexels-mobile-app-night.jpg" alt="点指之间 APP" />
        <i class="grid"></i>
        <span class="hud left">CONSUMER APP</span>
        <span class="hud right">DZZJ · VALUE NETWORK</span>
<!--        <i class="phone">-->
<!--          <span class="screen-glow"></span>-->
<!--          <span class="app-core">点</span>-->
<!--        </i>-->
      </section>

      <span class="mobile-eyebrow page-kicker">Consumer App · 用户生态入口</span>
      <h1>让每一次交互<br />都有价值回响</h1>
      <p class="intro">点指之间是生态的用户入口。用户在内容消费、广告互动、游戏娱乐、签到与分享中的有效参与，将获得活跃积分，并通过 AI 驱动的动态转换机制沉淀为能量积分。</p>

      <div class="metric3">
        <div><strong>行为即价值</strong><span>参与机制</span></div>
        <div><strong>活跃 → 能量</strong><span>持续流转</span></div>
        <div><strong>生态权益</strong><span>可持续使用</span></div>
      </div>

      <section class="mobile-card">
        <span class="mobile-eyebrow title">Participation · 参与路径</span>
        <div class="workflow">
          <div v-for="item in paths" :key="item.no" class="wf-step">
            <i class="wf-no">{{ item.no }}</i>
            <div><strong>{{ item.title }}</strong><p>{{ item.text }}</p></div>
          </div>
        </div>
      </section>

      <section class="mobile-card">
        <span class="mobile-eyebrow title">Scenes · 生活场景</span>
        <div class="scene-tags">
          <span v-for="scene in scenes" :key="scene">{{ scene }}</span>
        </div>
      </section>

      <section class="mobile-card privacy">
        <span class="mobile-eyebrow title">Privacy · 隐私与安全</span>
        <p>仅在你授权后收集必要信息，交互数据用于保障服务安全与积分结算。你可以随时在 APP 内查看隐私协议和管理授权。</p>
      </section>

      <div class="dock">
        <div>
          <small>官方发布 · 安全检测</small>
          <strong>下载点指之间</strong>
        </div>
        <RouterLink class="mobile-btn mobile-btn-primary" :to="registerTo">注册并下载</RouterLink>
      </div>
    </div>
    <MobileTabbar active="app" />
    <MobileServiceFloating raised />
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import MobileTabbar from '@/components/mobile/MobileTabbar.vue'
import MobileServiceFloating from '@/components/mobile/MobileServiceFloating.vue'

const route = useRoute()
const registerTo = computed(() => ({ path: '/mobile/register', query: route.query }))
const paths = [
  { no: '01', title: '内容与互动', text: '参与内容消费、广告互动和游戏娱乐，形成有效的日常参与。' },
  { no: '02', title: '活跃积分', text: '签到、分享和任务完成获得活跃积分，记录真实参与行为。' },
  { no: '03', title: '能量与权益', text: '活跃积分经 AI 动态转换沉淀为能量积分，用于生态消费。' }
]
const scenes = ['内容消费', '广告互动', '游戏娱乐', '签到分享', '生态消费', '生活场景']
</script>

<style scoped>
.app-screen { padding-bottom: calc(72px + env(safe-area-inset-bottom)); }
.mobile-topnav.transparent { background: none; backdrop-filter: none; }
.mobile-topnav-title.compact { font-size: 13px; }
.mobile-icon-btn.solid { background: rgba(5,12,24,.7); }
.app-hero { position: relative; height: 210px; display: flex; align-items: center; justify-content: center; margin: 0 -18px; background: radial-gradient(200px 130px at 50% 100%, rgba(155,140,255,.3), transparent 72%), linear-gradient(160deg,#191736,#12102a 55%,#090816); }
.hero-image { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; filter:saturate(1.05); }
.app-hero::after { content:""; position:absolute; inset:0; z-index:1; background:linear-gradient(180deg,rgba(2,5,13,.16),rgba(2,5,13,.76)); }
.grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(222,246,255,.055) 1px,transparent 1px),linear-gradient(90deg,rgba(222,246,255,.055) 1px,transparent 1px); background-size:24px 24px; mask-image:radial-gradient(circle at 50% 60%,#000 0 30%,transparent 78%); }
.hud { position:absolute; top:18px; z-index:2; color:rgba(155,140,255,.78); font-size:9px; font-weight:800; letter-spacing:.22em; }
.hud.left { left:20px; }.hud.right { right:20px; color:rgba(255,207,106,.7); }
.phone { position:relative; z-index:2; width:88px; height:142px; border:2px solid rgba(155,140,255,.62); border-radius:20px; background:linear-gradient(180deg,rgba(9,8,24,.96),rgba(4,5,13,.9)); box-shadow:0 0 42px rgba(155,140,255,.38); display:flex; align-items:center; justify-content:center; }
.screen-glow { position:absolute; inset:8px; border-radius:14px; background:radial-gradient(circle at 50% 30%, rgba(155,140,255,.28), transparent 68%); }
.app-core { position:relative; z-index:1; width:40px; height:40px; display:flex; align-items:center; justify-content:center; border-radius:50%; color:#04110f; font-size:16px; font-weight:900; background:radial-gradient(circle at 32% 28%,#8df5de,#46d6b6 60%,#2eb898); box-shadow:0 0 24px rgba(98,244,214,.5); }
.page-kicker { margin-top:20px; }
h1 { margin:12px 2px 10px; font-size:27px; line-height:1.26; font-weight:900; }
.intro { margin:0 2px 16px; color:var(--mobile-muted); font-size:12px; line-height:1.72; }
.metric3 { display:grid; grid-template-columns:repeat(3,1fr); gap:8px; }
.metric3 div { position:relative; overflow:hidden; padding:12px 7px; border:1px solid rgba(155,140,255,.24); border-radius:12px; text-align:center; background:linear-gradient(180deg,rgba(155,140,255,.08),rgba(255,255,255,.015)); }
.metric3 strong { display:block; color:var(--mobile-violet); font-size:12px; font-weight:900; }
.metric3 span { display:block; margin-top:3px; color:var(--mobile-quiet); font-size:9.5px; font-weight:600; }
.mobile-card { margin-top:14px; }
.title { margin-bottom:10px; }
.workflow { display:flex; flex-direction:column; }
.wf-step { position:relative; display:flex; gap:12px; padding-bottom:16px; }
.wf-step:last-child { padding-bottom:0; }
.wf-step::before { content:""; position:absolute; top:34px; bottom:2px; left:15px; width:1px; background:linear-gradient(180deg,rgba(155,140,255,.42),rgba(155,140,255,.08)); }
.wf-step:last-child::before { display:none; }
.wf-no { width:31px; height:31px; flex:0 0 31px; display:flex; align-items:center; justify-content:center; border:1.5px solid rgba(155,140,255,.5); border-radius:50%; color:var(--mobile-violet); font-size:11px; font-weight:900; background:rgba(155,140,255,.08); font-style:normal; }
.wf-step strong { display:block; margin-bottom:3px; font-size:13.5px; font-weight:800; }
.wf-step p { color:var(--mobile-quiet); font-size:11px; line-height:1.6; }
.scene-tags { display:flex; flex-wrap:wrap; gap:7px; }
.scene-tags span { padding:6px 10px; border:1px solid rgba(155,140,255,.26); border-radius:999px; color:#c9c0ff; font-size:11px; font-weight:700; background:rgba(155,140,255,.08); }
.privacy p { margin-top:8px; color:var(--mobile-muted); font-size:11.5px; line-height:1.7; }
.dock { position:sticky; bottom:calc(68px + env(safe-area-inset-bottom)); display:flex; align-items:center; gap:12px; margin:18px -18px 0; padding:12px 18px; border-top:1px solid rgba(222,246,255,.16); background:linear-gradient(180deg,rgba(2,5,13,0),rgba(2,5,13,.96) 40%); backdrop-filter:blur(10px); }
.dock > div { flex:1; min-width:0; }
.dock small { display:block; margin-bottom:2px; color:var(--mobile-quiet); font-size:10.5px; font-weight:600; }
.dock > div > strong { display:block; font-size:18px; font-weight:900; }
.dock .mobile-btn { flex:0 0 auto; min-width:132px; }
</style>
